import { render, staticRenderFns } from "./CustomStepper.vue?vue&type=template&id=4ff60d5c&scoped=true&"
import script from "./CustomStepper.vue?vue&type=script&lang=js&"
export * from "./CustomStepper.vue?vue&type=script&lang=js&"
import style0 from "./CustomStepper.vue?vue&type=style&index=0&id=4ff60d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff60d5c",
  null
  
)

export default component.exports